import { ISettlementListParams } from '@src/type/business/businessSettlement'
import instance from '../axios'

export const BusinessSettlementApis = {
  getSettlementMain: () => instance.get(`/v1/corporate/settlement`),
  getSettlementList: (data: ISettlementListParams) => instance.post(`/v1/corporate/settlement/list`, data),
  getSettlementInfo: (data: string) => instance.get(`/v1/corporate/settlement/${data}`),
  getSettleClaimCard: () => instance.get(`/v1/corporate/payment/claim/card`),
}
